import { v4 as uuidv4 } from 'uuid';
import { DisclosureContent } from '../../../../vtex-apps/disclosure-layout/DisclosureContent/default';
import { DisclosureLayout } from '../../../../vtex-apps/disclosure-layout/DisclosureLayout/default';
import { DisclosureLayoutGroup } from '../../../../vtex-apps/disclosure-layout/DisclosureLayoutGroup/default';
import { DisclosureStateIndicator } from '../../../../vtex-apps/disclosure-layout/DisclosureStateIndicator/default';
import { DisclosureTrigger } from '../../../../vtex-apps/disclosure-layout/DisclosureTrigger/default';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { ProductSpecificationGroup } from '../../../../vtex-apps/product-specification/ProductSpecificationGroup/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { ProductDescription } from '../../../../vtex-apps/store-components/ProductDescription/default';
import { ProductSpecification } from '../../../../vtex-apps/product-specification/ProductSpecification/default';
import { ProductSpecificationText } from '../../../../vtex-apps/product-specification/ProductSpecificationText/default';
import { IconCaret } from '../../../../vtex-apps/icons/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';
import { ProductSpecificationValues } from '../../../../vtex-apps/product-specification/ProductSpecificationValues/default';

export default function ProductDescriptionComponent() {
	return {
		componentName: 'VisibilityLayout',
		componentId: uuidv4(),
		componentGroup: 'ProductSpecificationSection',
		variables,
		props: VisibilityLayout({ mzTitle: 'MZ | Especificações do produto (On/Off)' }).props,
		childrenComponents: [
			FlexLayoutRow({ blockClass: 'flex-row__prod-spec-sect-2', mzTitle: 'MZ | Especificações do produto' }, [
				FlexLayoutCol({ blockClass: 'flex-col__prod-spec-sect-2' }, [
					DisclosureLayoutGroup({}, [
						DisclosureLayout({ animated: true }, [
							DisclosureTrigger(
								{
									blockClass: 'disclosure-trigger_prod-spec-sect-2',
									as: 'h3',
								},
								[
									RichText({
										blockClass: 'rich-text__prod-spec-sect-2',
										text: 'Descrição',
										textAlignment: 'left',
									}),
									DisclosureStateIndicator({
										Hide: IconCaret({
											orientation: 'up',
											activeClassName: 'disclosure-trigger_prod-spec-sect-2',
											mutedClassName: 'disclosure-trigger_prod-spec-sect-2',
											handle:
												'caretIcon--disclosure-trigger_prod-spec-sect-2 caretIcon vtex-store-icons-0-x-caretIcon vtex-store-icons-0-x-caretIcon--disclosure-trigger_prod-spec-sect-2',
										}),
										Show: IconCaret({
											orientation: 'down',
											activeClassName: 'disclosure-trigger_prod-spec-sect-2',
											mutedClassName: 'disclosure-trigger_prod-spec-sect-2',
											handle:
												'caretIcon--disclosure-trigger_prod-spec-sect-2 caretIcon vtex-store-icons-0-x-caretIcon vtex-store-icons-0-x-caretIcon--disclosure-trigger_prod-spec-sect-2',
										}),
									}),
								],
							),
							DisclosureContent({ blockClass: 'disclosure-content_prod-spec-sect-2' }, [
								ProductDescription({
									blockClass: 'description_prod-spec-sect-2',
									collapseContent: false,
									showTitle: false,
								}),
							]),
						]),
						DisclosureLayout({ animated: true }, [
							DisclosureTrigger(
								{
									blockClass: 'disclosure-trigger_prod-spec-sect-2',
									as: 'h3',
								},
								[
									RichText({
										blockClass: 'rich-text__prod-spec-sect-2',
										text: 'Especificações',
										textAlignment: 'left',
									}),
									DisclosureStateIndicator({
										Hide: IconCaret({
											orientation: 'up',
											activeClassName: 'disclosure-trigger_prod-spec-sect-2',
											mutedClassName: 'disclosure-trigger_prod-spec-sect-2',
											handle:
												'caretIcon--disclosure-trigger_prod-spec-sect-2 caretIcon vtex-store-icons-0-x-caretIcon vtex-store-icons-0-x-caretIcon--disclosure-trigger_prod-spec-sect-2',
										}),
										Show: IconCaret({
											orientation: 'down',
											activeClassName: 'disclosure-trigger_prod-spec-sect-2',
											mutedClassName: 'disclosure-trigger_prod-spec-sect-2',
											handle:
												'caretIcon--disclosure-trigger_prod-spec-sect-2 caretIcon vtex-store-icons-0-x-caretIcon vtex-store-icons-0-x-caretIcon--disclosure-trigger_prod-spec-sect-2',
										}),
									}),
								],
							),
							DisclosureContent({ blockClass: 'disclosure-content_prod-spec-sect-2' }, [
								ProductSpecificationGroup({}, [
									ProductSpecification({}, [
										FlexLayoutRow(
											{
												mzDontAddHover: true,
												blockClass: 'row__disclosure__prod-spec-sect-2',
												preserveLayoutOnMobile: true,
											},
											[
												FlexLayoutCol(
													{
														blockClass: 'col__disclosure__prod-spec-sect-2',
														width: { desktop: '25%', tablet: '100%', phone: '100%' },
													},
													[
														ProductSpecificationText({
															blockClass: 'spec-name__prod-spec-sect-2',
															message: '{specificationName}',
														}),
													],
												),
												FlexLayoutCol(
													{
														blockClass: 'col__disclosure__prod-spec-sect-2',
														width: { desktop: '25%', tablet: '100%', phone: '100%' },
													},
													[
														ProductSpecificationValues({}, [
															ProductSpecificationText({
																blockClass: 'spec-name__prod-spec-sect-2',
																message: '{specificationValue}',
															}),
														]),
													],
												),
											],
										),
									]),
								]),
							]),
						]),
					]),
				]),
			]),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--neutral-color-high-light', to: '--pss-2-bg-color', name: 'Background' },
			{ from: '--text-color-1', to: '--pss-2-trigger-text-color', name: 'Trigger Text' },
			{ from: '--transparent', to: '--pss-2-trigger-bg-color', name: 'Trigger Background' },
			{ from: '--transparent', to: '--pss-2-box-bg-color', name: 'Content Background' },
			{ from: '--text-color-1', to: '--pss-2-specification-arrow-color', name: 'Trigger Arrow' },
			{ from: '--neutral-color-high-medium', to: '--pss-2-trigger-border-color', name: 'Trigger Border' },
			{ from: '--neutral-color-high-medium', to: '--pss-2-line-border-color', name: 'Specification Border' },
			{ from: '--text-color-1', to: '--pss-2-description-text-color', name: 'Description Text' },
			{ from: '--text-color-1', to: '--pss-2-specification-name-text-color', name: 'Spec Name Text' },
			{ from: '--text-color-1', to: '--pss-2-specification-value-text-color', name: 'Spec Value Text' },
			{ from: '--transparent', to: '--pss-2-specification-odd-color', name: 'Spec Odd Background' },
			{ from: '--transparent', to: '--pss-2-specification-even-color', name: 'Spec Even Background' },
		],
	},
	{
		type: 'borderWidth',
		list: [
			{ from: '--border-width-hairline', to: '--pss-2-trigger-bw', name: 'Trigger' },
			{ from: '--border-width-none', to: '--pss-2-line-bw', name: 'Specification Line' },
		],
	},
	{
		type: 'borderRadius',
		list: [{ from: '--border-radius-none', to: '--pss-2-box-br', name: 'Content Box' }],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-md', to: '--pss-2-trigger-fs', name: 'Trigger' },
			{ from: '--font-size-sm', to: '--pss-2-description-fs', name: 'Content Box' },
			{ from: '--font-size-sm', to: '--pss-2-specification-name-fs', name: 'Specification Name' },
			{ from: '--font-size-sm', to: '--pss-2-specification-value-fs', name: 'Specification Value' },
		],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-700', to: '--pss-2-trigger-fw', name: 'Trigger' },
			{ from: '--font-weight-400', to: '--pss-2-description-fw', name: 'Content Box' },
			{ from: '--font-weight-700', to: '--pss-2-specification-name-fw', name: 'Specification Name' },
			{ from: '--font-weight-400', to: '--pss-2-specification-value-fw', name: 'Specification Value' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--pss-2-trigger-ff', name: 'Trigger' },
			{ from: '--main-font', to: '--pss-2-description-ff', name: 'Content Box' },
			{ from: '--main-font', to: '--pss-2-specification-name-ff', name: 'Specification Name' },
			{ from: '--main-font', to: '--pss-2-specification-value-ff', name: 'Specification Value' },
		],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-xxxs', to: '--pss-2-trigger-size', name: 'Trigger' },
			{ from: '--spacing-xxxs', to: '--pss-2-line-size', name: 'Specification Line' },
			{ from: '--spacing-xxxs', to: '--pss-2-padding-x', name: 'Padding X' },
		],
	},
];
